import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token || null || ""}`,
  "Content-Type": "application/json",
});

const authOnlyHeaders = (token) => ({
  Authorization: `Bearer ${token || null || ""}`,
});

export async function getTechnicianStatus(token) {
  try {
    const res = await axios.get(`${API}/technicians/me/status`, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    console.error("Technician status error:", err);
    if (err.response?.data?.detail) {
      throw new Error(err.response.data.detail);
    }
    throw new Error("Unable to load technician status.");
  }
}

export async function getTechnicianProfile(token) {
  try {
    const res = await axios.get(`${API}/technicians/me/profile`, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    console.error("Technician profile error:", err);
    if (err.response?.data?.detail) {
      throw new Error(err.response.data.detail);
    }
    throw new Error("Unable to load technician profile.");
  }
}

export async function updateTechnicianProfile(payload, token) {
  try {
    const res = await axios.put(`${API}/technicians/me/profile`, payload, {
      headers: {
        ...authHeaders(token),
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (err) {
    console.error("Technician profile save error:", err);
    if (err.response?.data?.detail) {
      throw new Error(err.response.data.detail);
    }
    throw new Error("Unable to save technician profile.");
  }
}

export async function getTechnicianOnboarding(token, salonId) {
  try {
    const res = await axios.get(`${API}/technicians/me/onboarding`, {
      params: salonId != null ? { salon_id: salonId } : undefined,
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    console.error("Technician onboarding error:", err);
    if (err.response?.data?.detail) {
      throw new Error(err.response.data.detail);
    }
    throw new Error("Unable to load technician onboarding status.");
  }
}

export async function setupTechnician(payload, token) {
  try {
    const res = await axios.post(`${API}/technicians/me/setup`, payload, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    console.error("Technician setup error:", err);
    if (err.response?.data?.detail) {
      throw new Error(err.response.data.detail);
    }
    throw new Error("Unable to complete technician setup.");
  }
}

export async function getTechnicianHours(date, token) {
  try {
    const res = await axios.get(`${API}/technicians/me/hours`, {
      params: { date },
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    console.error("Technician hours error:", err);
    if (err.response?.data?.detail) {
      throw new Error(err.response.data.detail);
    }
    throw new Error("Unable to load technician hours.");
  }
}

export async function getMyWeeklyHours(token) {
  try {
    const res = await axios.get(`${API}/technicians/me/weekly-hours`, {
      headers: authHeaders(token),
    });
    const payload = res.data;
    return Array.isArray(payload) ? payload : [];
  } catch (err) {
    console.error("Technician weekly hours error:", err);
    if (err.response?.data?.detail) {
      throw new Error(err.response.data.detail);
    }
    throw new Error("Unable to load weekly working hours.");
  }
}

export async function saveMyWorkingHours(payload, token) {
  try {
    const res = await axios.put(`${API}/technicians/me/hours`, payload, {
      headers: {
        ...authHeaders(token),
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (err) {
    console.error("Technician working hours save error:", err);
    if (err.response?.data?.detail) {
      throw new Error(err.response.data.detail);
    }
    throw new Error("Unable to save working hours.");
  }
}

export async function getTechnicianAccount(token) {
  try {
    const res = await axios.get(`${API}/technicians/me/account`, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    console.error("Technician account error:", err);
    if (err.response?.data?.detail) {
      throw new Error(
        typeof err.response.data.detail === "string"
          ? err.response.data.detail
          : err.response.data.detail?.message || "Unable to load technician account."
      );
    }
    throw new Error("Unable to load technician account.");
  }
}

export async function updateTechnicianAccount(payload, token) {
  try {
    const res = await axios.put(`${API}/technicians/me/account`, payload, {
      headers: authHeaders(token),
    });
    return res.data;
  } catch (err) {
    console.error("Technician account update error:", err);
    if (err.response?.data?.detail) {
      throw new Error(
        typeof err.response.data.detail === "string"
          ? err.response.data.detail
          : err.response.data.detail?.message || "Unable to update technician account."
      );
    }
    throw new Error("Unable to update technician account.");
  }
}

export async function uploadTechnicianAccountPhoto(file, token) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(`${API}/technicians/me/account/photo`, formData, {
    headers: authOnlyHeaders(token),
  });
  return res.data;
}

export async function removeTechnicianAccountPhoto(token) {
  const res = await axios.delete(`${API}/technicians/me/account/photo`, {
    headers: authOnlyHeaders(token),
  });
  return res.data;
}
